import { GripVerticalIcon } from 'lucide-react'

import type { ConfigSection } from '@/modules/projects'
import { SectionIcon } from './SectionIcon'

interface AvailableSectionItemProps {
  section: ConfigSection
  onDragStart: (key: ConfigSection['key']) => void
}

export const AvailableSectionItem = ({
  section,
  onDragStart,
}: AvailableSectionItemProps) => {
  const handleDragStart = (event: React.DragEvent) => {
    event.dataTransfer.setData('text/plain', section.key)
    event.dataTransfer.effectAllowed = 'move'
    onDragStart(section.key)
  }

  return (
    <div
      draggable
      onDragStart={handleDragStart}
      className="flex w-full items-center gap-2 rounded-lg border border-dashed bg-white px-3 py-2.5 text-left cursor-grab active:cursor-grabbing select-none"
    >
      <GripVerticalIcon className="h-3.5 w-3.5 shrink-0 text-muted-foreground/40" />
      <SectionIcon sectionKey={section.key} />
      <div className="flex-1 min-w-0">
        <span className="text-sm font-medium text-muted-foreground">
          {section.label}
        </span>
        <p className="text-xs text-muted-foreground/70 truncate">
          {section.description}
        </p>
      </div>
    </div>
  )
}
